import { Component, EventEmitter, OnInit, Output, ViewChild, ChangeDetectorRef, TemplateRef, ElementRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpParams } from '@angular/common/http';
import { LoadingService } from 'src/app/core/services/loading.service';
import { FirmaStateService } from 'src/app/core/states/firma/firma-state.service';
import { ActivatedRoute, Router } from '@angular/router';
import { lastValueFrom, Subject, takeUntil } from 'rxjs';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SubidaDocumentoSimpleComponent } from './../../subida-documento-simple/subida-documento.simple';
import { AsociacionFirmaSimpleComponent } from '../../asociacion-firma-simple/asociacion-firma-simple.component';
import { BatchConfigurationComponent } from 'src/app/shared/components/batch-configuration/batch-configuration.component';
import { StepperComponent } from 'src/app/shared/components/stepper/stepper.component';
import { LoteService } from 'src/app/core/services/lote.service';
import { LoteCertificado } from 'src/app/models/LoteCertificado.model';
import { LoteCertificadoService } from 'src/app/core/services/lote-certificado.service';
import { LoteDetalleUrlService } from 'src/app/core/services/lote-detalle-url.service';
import { LoteDetalleUrl } from 'src/app/models/LoteDetalleUrl.model';
import { DownloadService } from "src/app/core/services/download.service";
import { Lote } from 'src/app/models/Lote.model';
import { Location } from '@angular/common';

import { Certificado } from 'src/app/models/Certificado.model';
import { CertificadoService } from 'src/app/core/services/certificado.service';
import { k } from 'src/environments/properties';
interface Item {
    id?: string;
    titulo: string;
    notificacion_firmantes: string;
    estado: string;
    id_estado: number;
    fecha_creacion: string;
}

@Component({
    selector: 'app-adminsimple-component',
    templateUrl: './admin-simple.component.html',
    styleUrls: ['./admin-simple.css'],
})
export class AdminSimpleComponent implements OnInit {

    @Output() firmaChangeStepper: EventEmitter<any> = new EventEmitter<any>();
    @ViewChild(BatchConfigurationComponent) batchConfigComponent!: BatchConfigurationComponent;
    @ViewChild(SubidaDocumentoSimpleComponent) subidaDocumentoSimpleComponent!: SubidaDocumentoSimpleComponent;
    @ViewChild(AsociacionFirmaSimpleComponent) asociacionFirmaSimpleComponent!: AsociacionFirmaSimpleComponent;
    @ViewChild(StepperComponent) StepperComponent!: StepperComponent;
    @ViewChild('tituloInput') tituloInput!: ElementRef<HTMLInputElement>;
    @ViewChild('firmaComponent') firmaComponent: TemplateRef<any>;

    batchConfigForm: FormGroup;
    emailUser: string;
    stepActual = 0;
    userModule = true;
    public short_estado_lote: string = '';
    public titulo: string = ''
    public titulo_step: string = ''
    public info_step: string = ''
    public animationArray = ['/assets/lottie/uploading2.json', '/assets/lottie/edit-icon.json', '/assets/lottie/signature2.json'];
    toast = Swal;
    idLote: any = null; // Para almacenar el ID del lote
    lote: Lote;
    public loteCertificados2: LoteCertificado[] = [];
    private destroy$ = new Subject<void>(); // Usado para desuscribir los Observables al destruir el componente

    public loteCertificados: LoteCertificado[] = [];
    public formAsociarCertificado: FormGroup;
    public certificados: Certificado[] = [];
    public loteDetalleUrls: LoteDetalleUrl[] = [];

    public IsLoading: boolean;
    public countSig = 0;
    public findAllCount = 0;
    public masarchvios: boolean = false;

    constructor(
        private modalService: NgbModal,
        private firmaService: FirmaStateService,
        private loteService: LoteService,
        private firmaStateService: FirmaStateService,
        private loteCertificadoService: LoteCertificadoService,
        private loteDetalleUrlService: LoteDetalleUrlService,
        private certificadoService: CertificadoService,
        private downloadService: DownloadService,
        private cd: ChangeDetectorRef,
        private router: Router,
        public loading: LoadingService,
        private fb: FormBuilder,
        private route: ActivatedRoute,
        private location: Location
    ) {

    }


    ngOnInit() {

        this.toastAlert();
        this.firmaService.resetForm();
        this.emailUser = localStorage.getItem(k.correo);

        this.route.paramMap
            .pipe(takeUntil(this.destroy$)) // Desuscribe automáticamente al destruir el componente
            .subscribe(async params => {
                // 'id' es el nombre del parámetro definido en tu configuración de rutas
                const id = params.get('id');
                if (Number(id)) {
                    this.idLote = id; // El '+' convierte el string a número
                    // procedemos a precargar la data de los pasos
                    await this.precargarData(this.idLote);
                    await this.validateUserModule();
                } else {
                    this.idLote = null;
                }
            });

        this.batchConfigForm = this.fb.group({
            titulo: ['', [Validators.required, Validators.minLength(3)]], // Título es requerido y debe tener al menos 3 caracteres
            notificacion_firmantes: [true], // Checkbox Notificar firma (valor inicial es false)
            firma_por_plantilla: [false],
            firma_simple: [true],
            es_grupo: [false],
            id_plantilla: null,
            disco: ['local']
        });
    }

    ngAfterViewInit() {
        this.cd.detectChanges();
    }


    changeStepChildren(stepper: any) {
        this.onStepChange(stepper);
    }

    /*AQUI EMPIEZA LA CREACION DE LOTE Y LA CARGA DE DOCUMENT0*/

    async onStepChange(nuevoPaso: number, evento: string = '') {

        if (this.loading.loading()) {
            return;
        }

        if (this.StepperComponent) {
            this.StepperComponent.activeSpinning(true);
        }

        this.loading.start();
        this.stepActual = nuevoPaso;

        let canAdvance = false;

        switch (this.stepActual) {
            case 0:
                this.titulo_step = 'Carga de documento(s) a configurar.';
                this.info_step = '';
                if (this.subidaDocumentoSimpleComponent) {
                    
                    if (!this.batchConfigForm.valid) {
                        this.alert('warning', 'No hay archivo.', 'Para continuar es necesario, colocar un archivo.' );
                        this.StepperComponent.activeSpinning(false);
                        // return false;
                    }

                    let lote = await this.saveFormData();

                    if (lote) {
                        canAdvance = await this.validCantidadCertificados();
                    }

                }
                break;

            case 1:
                this.titulo_step = 'Asociar Firmantes - certificados digitales con áreas de firma.';
                this.info_step = 'Buscar por correo electrónico y asocia su certificado.';

                if (this.asociacionFirmaSimpleComponent) {
                    canAdvance = await this.asociacionFirmaSimpleComponent.validCoordenadas(evento);
                    this.StepperComponent.activeSpinning(false);
                }
                break
            case 2:
                this.titulo_step = 'Firma de documento.';
                this.info_step = 'Se puede pre visualizar el documento a firmar.';

                break;
        }

        this.StepperComponent.activeSpinning(false);

        if (canAdvance) {
            this.stepActual++;
            this.firmaService.setCurrentStep(this.stepActual);
        }

        this.loading.stop();

    }

    obtenerArchivo(data: any): void {

        this.masarchvios = data.varios;

        const archivos = data.archivo ?? [];

        if (archivos.length === 1) {

            this.batchConfigForm.patchValue({
                titulo: archivos[0].name
            });
        } else {
            this.batchConfigForm.patchValue({
                titulo: ''
            });
        }

        if (archivos > 1) {
            setTimeout(() => {
                this.tituloInput?.nativeElement.focus();
            });
        }
    }

    async validCantidadCertificados(): Promise<boolean> {

        const certificados = await this.indexLoteCertificado();

        if (certificados.length === 0) {

            const crear = await this.realizarBusqueda(this.emailUser);

            if (!crear) {
                this.alert('warning', 'Debe agregar certificados antes de continuar');
                return false;
            } else {
                return true;
            }
        }

        return true;
    }

    async validateLoteCertificado() {

        let validarCantidadCertificados = (this.loteCertificados.length > 0) ? true : false

        if (!validarCantidadCertificados) {
            this.alert('warning', 'Debe agregar certificados antes de continuar');
        }

        return (this.loteCertificados.length > 0) ? true : false;
    }

    public async saveFormData(): Promise<boolean> {

        if (!this.batchConfigForm.valid) {
            this.batchConfigForm.markAllAsTouched();
            return false;
        }

        const formValues = this.batchConfigForm.value;
        let lote: Lote | null = null;

        if (this.idLote) {
            lote = await lastValueFrom(
                this.loteService.updLote(formValues, this.idLote)
            ) as Lote;
        } else {
            lote = await lastValueFrom(
                this.loteService.post(formValues)
            ) as Lote;

            this.idLote = lote.id;
        }

        this.firmaStateService.updateLote(lote);

        if (!lote) {
            return false;
        }

        if (!this.subidaDocumentoSimpleComponent) {
            return false;
        }

        return await this.subidaDocumentoSimpleComponent.subirDocumentos();
    }

    async precargarData(id: number): Promise<any> {
        this.lote = (this.firmaStateService.getCurrentState())?.lote;

        if (!this.lote) { // sino hemos precargado anteriormente nuestro estado global procedemos a cargar y redireccionar el stepper
            this.lote = (await this.showLote(id)) as Lote;
            await this.indexLoteCertificado();
            await this.indexLoteDetalleUrl();

            this.firmaStateService.updateLote(this.lote as Lote);
            let stepper = 1;


            if (await this.validCoordenadas()) stepper = 2;
            await this.onStepChange(stepper, 'NEXT');
        }

        this.batchConfigForm.setValue({
            disco: this.lote?.disco,
            titulo: this.lote?.titulo,
            notificacion_firmantes: this.lote.notificacion_firmantes,
            firma_por_plantilla: this.lote?.firma_por_plantilla,
            firma_simple: this.lote?.firma_simple,
            es_grupo: this.lote?.es_grupo,
            id_plantilla: (this.lote?.plantilla?.id ? this.lote?.plantilla?.id : '')
        });
    }

    async indexLoteDetalleUrl() {
        const response = await lastValueFrom(this.loteDetalleUrlService.indexDetalleUrl(this.idLote));
        this.loteDetalleUrls = response.body as LoteDetalleUrl[];
        if (this.loteDetalleUrls.length > 1) {
            this.masarchvios = true;
            setTimeout(() => {
                this.tituloInput?.nativeElement.focus();
            });
        }
        return response.body as LoteDetalleUrl[];
    }

    async showLote(id: number) {
        const lote = await lastValueFrom(this.loteService.show(id));
        return lote;
    }

    async validateUserModule() {

        const response = this.firmaStateService.getCurrentState().lote_certificado;
        const usuarioCreacion = this.firmaStateService.getCurrentState().lote?.usuario; // Usuario que creo el lote


        const lista = Array.isArray(response) ? (response as LoteCertificado[]) : [];
        this.loteCertificados = lista;
        const userId = localStorage.getItem(k.user_id) ?? '';

        let existe = false;

        //Si el usuario de la sesión, es el mismo que creo el lote
        existe = usuarioCreacion.id == userId;

        //Si no es quien creo el lote, se valida que sea uno de los usuarios firmantes
        if (this.loteCertificados.length > 0 && !existe) {
            //Se valida que el usuario existe dentro de los firmantes asociados al lote
            existe = lista.some(crt => String(crt?.usuario?.id) === String(userId));
        }
        this.userModule = existe
    }

    /*AQUI FINALIZA LA CREACION DE LOTE Y LA CARGA DE DOCUMENT0*/

    async realizarBusqueda(correo: string) {
        let params = new HttpParams(); // Inicia un nuevo objeto HttpParams
        params = params.set('correo', correo);
        const response = await lastValueFrom(this.certificadoService.get<Certificado[]>({ params }));
        this.certificados = response.body ?? [];

        if (this.certificados.length > 0) {
            return await this.agregarCertificadoLote(this.certificados[0].id);
        }

    }

    async indexLoteCertificado() {
        const response = await lastValueFrom(this.loteCertificadoService.indexLoteCertificado(this.idLote));
        this.loteCertificados = response.body as LoteCertificado[];
        this.firmaStateService.updateLoteCertificado(this.loteCertificados);
        return this.loteCertificados;
    }

    async agregarCertificadoLote(certificado: any) {

        const body = { firmar_con_imagen: false }
        const response = await lastValueFrom(this.loteCertificadoService.putLoteCertificado(body, this.idLote, certificado));
        this.indexLoteCertificado();
        if (response) {
            this.router.navigate([`firmas/admin-simple/${this.idLote}`]);
            return true;
        } else {
            return false;
        }
    }

    async validCoordenadas() {
        await this.findAllCoordenadas();
        await this.countSignature();
        if (this.countSig != this.findAllCount) {
            return false;
        }

        return true;
    }

    async findAllCoordenadas() {
        const response = await lastValueFrom(this.loteDetalleUrlService.findAllCoordenadas(this.idLote));
        this.findAllCount = response.body.length;
        return this.findAllCount;
    }

    async countSignature() {
        let countCert = this.loteCertificados.length;
        let countDoc = this.loteDetalleUrls.length;

        this.countSig = (countCert * countDoc);
    }


    validateUltimaEtapaF(validate: string) {

        setTimeout(() => {
            this.short_estado_lote = validate;
        }, 0);
    }

    async descargarZipPorLote(nameZip: string) {

        this.downloadService
            .descargarZipPorLote(this.idLote, 'mis_documentos')
            .subscribe((blob: Blob) => {
                const fileName = `${nameZip}.zip`; // o el que quieras
                const a = document.createElement('a');
                const objectUrl = URL.createObjectURL(blob);
                a.href = objectUrl;
                a.download = fileName;
                a.click();
                URL.revokeObjectURL(objectUrl);
            });


    }



    rederict() {
        this.location.back();
    }

    volverInicio() {
        this.router.navigate(['/']); // o la ruta que quieras
    }

    toastAlert() {
        this.toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
            }
        });
    }

    alert(icontext: SweetAlertIcon, title: string, text: string = '') {
        this.toast.fire({
            icon: icontext,
            title: title,
            text: text
        });
    }
}
